import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { pendingTasksReducer } from "react-redux-spinner";
import app from "./app";
import data from "./data";

import patient from "./patient";

export default combineReducers({
  routing: routerReducer,
  pendingTasks: pendingTasksReducer,
  app,
  data,
  patient
});



// WEBPACK FOOTER //
// ./src/ducks/index.js